import { FormHelperText, Stack, Typography } from '@mui/material';
import { Controller, FieldPathByValue, FieldValues, UseControllerProps } from 'react-hook-form';

import RolesSpecialtiesSelector from './RolesSpecialtiesSelector';
import { RoleSpecialtyOption } from './types';

interface FormRolesSpecialtiesSelectorProps<TFieldValues extends FieldValues> extends UseControllerProps<TFieldValues> {
    name: FieldPathByValue<TFieldValues, RoleSpecialtyOption[]>;
    label?: string;
    disabled?: boolean;
}

export default function FormRolesSpecialtiesSelector<TFieldValues extends FieldValues>({
    control,
    name,
    label,
    disabled
}: FormRolesSpecialtiesSelectorProps<TFieldValues>) {
    return (
        <Controller
            name={ name }
            control={ control }
            render={ ({ field: { value, onChange }, fieldState }) => (
                <Stack gap={ 1 }>
                    { label && (
                        <Typography component="label"
                            variant="caption"
                            color="text.secondary"
                        >
                            { label }
                        </Typography>
                    ) }
                    <RolesSpecialtiesSelector
                        value={ value ?? [] }
                        onChange={ onChange }
                        disabled={ disabled }
                    />
                    { fieldState.error?.message && (
                        <FormHelperText error>{ fieldState.error.message }</FormHelperText>
                    ) }
                </Stack>
            ) }
        />
    );
}
